import { render, staticRenderFns } from "./lampOtherInfo.vue?vue&type=template&id=076a0a3a&scoped=true&"
import script from "./lampOtherInfo.vue?vue&type=script&lang=js&"
export * from "./lampOtherInfo.vue?vue&type=script&lang=js&"
import style0 from "./lampOtherInfo.vue?vue&type=style&index=0&id=076a0a3a&lang=less&scoped=true&"
import style1 from "./lampOtherInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a0a3a",
  null
  
)

export default component.exports